import { render, staticRenderFns } from "./roomTreeDivHasOwner.vue?vue&type=template&id=38b0b758&scoped=true"
import script from "./roomTreeDivHasOwner.vue?vue&type=script&lang=js"
export * from "./roomTreeDivHasOwner.vue?vue&type=script&lang=js"
import style0 from "./roomTreeDivHasOwner.vue?vue&type=style&index=0&id=38b0b758&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38b0b758",
  null
  
)

export default component.exports